module.exports = __webpack_public_path__ + "img/01.9ad41df8.jpg";